import { CircularProgress } from '@mui/material'
import Pagination from '@mui/material/Pagination'
import React, { useEffect } from 'react'
import Datatable from '../../../components/Datatable'
import Layout from '../../../Layouts/Layout'
import { BiLeftArrow, BiRightArrow } from 'react-icons/bi'
import { PaginationItem } from '@mui/material'
import ComissionApi from '../../../API/ComissionApi'
import QuickDate from "./../../../components/QuickDate"
import SearchAccoutingEntriesReq from '../../../Requests/ComissionPlan/SearchAccoutingEntriesReq'
import UserSelector from '../../../components/UserSelector'
import OrganizationSelector from '../../../components/OrganizationSelector'
const Index = () => {

    const [name, setName] = React.useState(null)
    const [description, setDescription] = React.useState(null)

    const [accountingEntries, setAccoutingEntries] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [currentPage, setCurrentPage] = React.useState(1)
    const [totalPages, setTotalPages] = React.useState(1)
    const [fromDate, setFromDate] = React.useState(null)
    const [toDate, setToDate] = React.useState(null)
    const [salesReps, setSalesReps] = React.useState([])
    const [organizations, setOrganizations] = React.useState([])

    const searchAccoutingEntries = () => {
        setLoading(true)
        const req = new SearchAccoutingEntriesReq()
        req.pagingParams.pageNumber = currentPage
        req.pagingParams.pageSize = 20
        req.name = name
        req.description = description
        req.fromDate = fromDate === "" ? null : fromDate
        req.toDate = toDate === "" ? null : toDate
        req.orgIds = organizations
        req.salesRepIds = salesReps
        
        ComissionApi.SearchAccountingEntries(req).then(
            (res) => {
                
                console.log(res)
                setTotalPages(res?.data?.totalPages)

                res?.data?.list.forEach((entry) => {
                    entry.salesRep = entry?.subject?.firstName + " " + entry?.subject?.lastName
                    
                }
            )

                setAccoutingEntries(res?.data?.list)
                setLoading(false)
            }
        )
    }




    const headers = [
        {
            name: "Entry ID",
            key: "id"
        },
        {
            name:"Timestamp",
            key:"timeStamp"
        },
        {
            name: "Sales Rep",
            key: "salesRep"
        },
        {
            name: "Name",
            key: "name"
        },
        {
            name: "Description",
            key: "description"
        },
        {
            name: "Amount",
            key: "amount"
        },
        {
            name: "Type",
            key: "type"
        },
    ]

    useEffect(
        () => {
            searchAccoutingEntries()
        }, [currentPage]
    )

    return (
        <Layout>
            <div className='manageLeadsContainer' >
                <div className='manageLeadsHeader'>
                    <h1 className='manageLeadsTitle'>Manage Accounting Entries</h1>
                    <div className='searchFiltersInput' >
                        <input value={name} onChange={(e) => { setName(e.target.value) }} placeholder='Name' />
                        <input value={description} onChange={(e) => { setDescription(e.target.value) }} placeholder='Description' />
                        <QuickDate setFrom={setFromDate} setTo={setToDate} />
                        <UserSelector placeholder='Select Sales Reps' conversationType={"Group"}  setUser={setSalesReps}  />
                        <OrganizationSelector placeholder='Select Organization' setUser={setOrganizations} multiple={true} />
                    </div>
                    <button onClick={searchAccoutingEntries} >Search</button>
                </div>
                {
                    loading ?
                        <div className='spinner'>
                            <CircularProgress sx={{color:"var(--color-icon)"}} />
                        </div>
                        :
                        <>
                            <Datatable headers={headers} list={accountingEntries} currentPage={currentPage} totalPages={totalPages} />
                        </>
                }
                <div className='pagination'>
                    <Pagination color='light' renderItem={(item)=>(
                    <PaginationItem  components={{
           
                        next: (props) => <button {...props}><BiRightArrow color='var(--color-icon)' /></button>,
                        first: (props) => <button {...props}>First</button>,
                        previous: (props) => <button {...props}><BiLeftArrow color='var(--color-icon)' /></button>
                      }}  {...item} sx={{color: "white"}} />
                )} count={totalPages} page={currentPage} onChange={(e, v) => { setCurrentPage(v) }} />
                </div>
            </div>
        </Layout>
    )
}

export default Index